module.exports = __webpack_public_path__ + "img/grid-white.ec72b311.png";